import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle, ShieldCheck, Star } from 'lucide-react';
export function Hero() {
  return <div className="relative bg-[#0B1C3E] text-white overflow-hidden" data-id="element-34">
      {/* Background Pattern Overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-35"></div>

      <div className="relative container mx-auto px-4 pt-2 pb-20 md:pt-2 md:pb-32 max-w-7xl" data-id="element-36">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-37">
          {/* Text Content */}
          <div className="flex-1 text-center z-10" data-id="element-38">
            <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-1 rounded-full mb-6 backdrop-blur-sm border border-white/20" data-id="element-39">
              <Star className="w-4 h-4 text-[#FFC107] fill-current" data-id="element-40" />
              <span className="text-xs font-medium  tracking-wide text-[#FFC107]" data-id="element-41">
                HEALTHPRODUCTSGURU
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl font-extrabold leading-tight mb-4" data-id="element-42">
              The Most Potent, <br data-id="element-43" />
              <span className="text-[#00adee]" data-id="element-44">Fast-Acting Formula</span> <br data-id="element-45" />
              For Prostate Health
            </h1>

            <div className="mb-2 flex justify-center" data-id="element-46">
              <img src="https://cdn.magicpatterns.com/uploads/pvfbq9zztFCoDBLN8JRekf/ChatGPT_Image_Jan_6,_2026,_01_32_50_AM-min2.png" alt="ProstaVive Bottles with 50% OFF" className="w-full max-w-md mx-auto" data-id="element-47" />
            </div>

            <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-48">
              ProstaVive is a powerful new formula designed to support healthy
              prostate function, strong flow, and better sleep. Experience the
              breakthrough today.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10" data-id="element-49">
              <a href="https://go.trkrgodom.com/click" data-id="element-50">
                <Button size="xl" className="shadow-[0_0_20px_rgba(40,167,69,0.5)]" data-id="element-51">
                  Order Now & Save 50%
                </Button>
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-gray-300" data-id="element-52">
              <div className="flex items-center gap-2" data-id="element-53">
                <ShieldCheck className="w-5 h-5 text-[#4CAF50]" data-id="element-54" />
                <span data-id="element-55">180-Day Guarantee</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-56">
                <CheckCircle className="w-5 h-5 text-[#4CAF50]" data-id="element-57" />
                <span data-id="element-58">100% Natural Ingredients</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-59">
                <CheckCircle className="w-5 h-5 text-[#4CAF50]" data-id="element-60" />
                <span data-id="element-61">Made in USA</span>
              </div>
            </div>
          </div>

          {/* Hero Image */}
        </div>
      </div>

      {/* Wave Divider */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-62">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="fill-white" data-id="element-63">
          <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z" data-id="element-64"></path>
        </svg>
      </div>
    </div>;
}